import { GetStaticProps } from 'next';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import { useTranslation } from 'react-i18next';
import ButtonWrap from '@/molecules/ButtonWrap/ButtonWrap';
import PageLeading from '@/molecules/PageLeading';
import MainTitle from '@/molecules/titles/MainTitle';
import SecondaryTitle from '@/molecules/titles/SecondaryTitle';
import SuccessOrFailure from '@/organisms/SuccessOrFailure';
import { ALIGNMENT_ENUM } from 'types/utils';

const NotFoundPage = () => {
  const { t } = useTranslation();

  return (
    <div className="min-h-screen bg-sand-50 flex items-center justify-center">
      <main className="grow max-w-1200">
        <PageLeading alignment={ALIGNMENT_ENUM.center}>
          <MainTitle alignment={ALIGNMENT_ENUM.center}>{t('oops')}</MainTitle>
        </PageLeading>
        <SuccessOrFailure>
          <SecondaryTitle subtitle={t('not-found-text')}>{t('not-found')}</SecondaryTitle>
          <ButtonWrap
            primary={{ children: t('contact-us'), href: 'https://support.altered.gg' }}
            secondary={{ children: t('return-home'), href: '/' }}
          />
        </SuccessOrFailure>
      </main>
    </div>
  );
};

export const getStaticProps: GetStaticProps = async ({ locale }) => {
  return {
    props: {
      ...(locale ? await serverSideTranslations(locale) : {}),
    },
    revalidate: 10000,
  };
};

export default NotFoundPage;
